/* 🤖 this file was generated by svg-to-ts */
export const iconTeth: {
  name: 'teth';
  data: string;
} = {
  name: 'teth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#treehouseeth__clip0_2520_217)"><path fill="currentColor" d="M16 0C7.16 0 0 7.17 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m6.16 15.61-1.98 1.17 1.98 1.17-6.19 8.72-6.19-8.72 1.98-1.17-1.98-1.17 6.19-10.27z"/></g><defs><clipPath id="treehouseeth__clip0_2520_217"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
